// Checks generated from an API response (the API editor's "From last response"): one
// "JSON value equals …" check per field, in the path syntax the executor's readJsonPath
// reads ($.a.b[0]['c d']) and the text form its compare() uses (null → "null", [] → "[]").

const MAX_CHECKS = 200;

// .key when it's a plain name, else ['key'] / ["key"]; null when neither can be written
// (the executor doesn't unescape quotes inside brackets)
const keyPath = (key) => {
	if (/^[A-Za-z_$][\w$-]*$/.test(key)) return `.${key}`;
	if (!/['\\]/.test(key)) return `['${key}']`;
	if (!/["\\]/.test(key)) return `["${key}"]`;
	return null;
};

const asText = (value) => (value === null ? "null" : typeof value === "object" ? JSON.stringify(value) : String(value));

/**
 * The response body as JSON, or why it can't be used: { json } or { error }.
 * `response` is a step result's metadata.api.response.
 */
export function responseJson(response) {
	if (!response) return { error: "Run this request first, then its response values can be added as checks." };
	const body = response.body || "";
	if (/… \(\d+ characters, truncated\)$/.test(body)) {
		return { error: "The last response was too large to keep in full (over 20,000 characters), so checks can't be made from it." };
	}
	try {
		return { json: JSON.parse(body) };
	} catch {
		return { error: "The last response isn't JSON." };
	}
}

/**
 * [{ path, expected }] for every value in `json` (leaves, plus empty lists and objects),
 * skipping paths an existing JSON check already covers. At most MAX_CHECKS; `more` says
 * how many were left out.
 */
export function checksFromJson(json, existingChecks = []) {
	const covered = new Set(existingChecks.filter((c) => c.source === "jsonPath").map((c) => (c.path || "").trim()));
	const rows = [];
	let more = 0;
	const walk = (value, path) => {
		const isList = Array.isArray(value);
		const isObject = value !== null && typeof value === "object";
		if (isObject && (isList ? value.length : Object.keys(value).length)) {
			if (isList) value.forEach((item, i) => walk(item, `${path}[${i}]`));
			else
				for (const [key, item] of Object.entries(value)) {
					const part = keyPath(key);
					if (part) walk(item, path + part);
				}
			return;
		}
		if (covered.has(path)) return;
		if (rows.length >= MAX_CHECKS) more++;
		else rows.push({ path, expected: asText(value) });
	};
	walk(json, "$");
	return { rows, more };
}
